export function formatNumber(value: any): number | string | undefined {
  if (typeof value === 'number') {
    if (value % 1) {
      return value.toFixed(2);
    }
    return value;
  }
  return undefined;
}

const compareNullValues = (a: number | null, b: number | null): number => {
  if (a === null) return 1;
  if (b === null) return -1;

  return a - b;
};

export const basicSort =
  (col: string | string[]) =>
  (a: any, b: any): number => {
    if (Array.isArray(col) && col.length) {
      if (a[col[0]] === null) return 1;
      if (b[col[0]] === null) return -1;

      return compareNullValues(a[col[0]][col[1]], b[col[0]][col[1]]);
    } else {
      return compareNullValues(a[col], b[col]);
    }
  };

export const compareSort =
  (col: string | string[], propName?: string) =>
  (a: any, b: any): number => {
    if (propName) {
      return compareSort(propName)(a[col], b[col]);
    }

    if (Array.isArray(col) && col.length) {
      if (a[col[0]] === null) return 1;
      if (b[col[0]] === null) return -1;

      return a[col[0]][col[1]]?.localeCompare(b[col[0]][col[1]]);
    } else {
      return a[col]?.localeCompare(b[col]);
    }
  };

export const compareAssigneeSort = (a: any, b: any): number => {
  const assignee1 = a?.assignee ? a.assignee : 'Unassigned';
  const assignee2 = b?.assignee ? b.assignee : 'Unassigned';
  return assignee1.localeCompare(assignee2);
};

export const compareEditorSort = (a: any, b: any): number => {
  const editor1 = a?.editor?.email ? a.editor.email : undefined;
  const editor2 = b?.editor?.email ? b.editor.email : undefined;
  return editor1.localeCompare(editor2);
};

export const formatHours = (val: number): number => {
  return val % 1 === 0 ? Math.trunc(val) : val;
};
